import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

const BASE_TITLE = 'Hitachi Energy SNCRP';

/** Mirrors legacy `AppComponent` browser-tab title: "Hitachi Energy SNCRP: {route title}" or the bare base title. */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);
    this.title.setTitle(routeTitle ? `${BASE_TITLE}: ${routeTitle}` : BASE_TITLE);
  }
}
